import {useEffect} from 'react'
import {Dispatch} from 'redux'
import {useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import * as auth_actions from '../../../setup/redux/auth/actions'

export function Logout() {
  const dispatch: Dispatch<any> = useDispatch()
  let navigate = useNavigate()
  useEffect(() => {
    dispatch(auth_actions.logout(navigate))
  }, [navigate, dispatch])
  return <></>
}
